import { ComponentStyleConfig } from '@chakra-ui/react'

/**
 * Extends base Button theme with 3p Figma design.
 * See RippleButton for the material ui behaviour, this was not possible in css only in this theme.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/092b20f3e93064c1db312062b76b420a7ed1703b/packages/theme/src/components/button.ts
 * @see https://www.figma.com/file/AVVZO09XE8fZ0uuOaJYcQg/B2C-Onboarding---for-Dev?node-id=2759%3A24812
 */
export const ButtonTheme: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
    size: 'lg'
  },
  baseStyle: {
    borderRadius: '40px',
    outline: 'none',
    border: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    fontWeight: 'normal',
    _disabled: {
      opacity: '0.4',
      cursor: 'not-allowed',
      boxShadow: 'none'
    }
  },
  sizes: {
    xs: {
      h: '24px',
      px: '12px',
      fontSize: '12px'
    },
    sm: {
      h: '32px',
      px: '12px',
      fontSize: '12px'
    },
    md: {
      h: '40px',
      px: '16px',
      fontSize: '12px'
    },
    lg: {
      h: '48px',
      px: '32px',
      fontSize: '20px'
    }
  },
  variants: {
    primary: {
      bg: 'linear-gradient(103.65deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%)',
      color: 'secondary.0',
      _hover: {
        bg: 'linear-gradient(102.49deg, #007ACC 0%, #014B8B 100%)',
        _disabled: {
          bg: 'neutral.100'
        }
      },
      _active: {
        bg: 'linear-gradient(98.39deg, #0063A7 0%, #01437D 100%)'
      },
      _disabled: {
        opacity: '1',
        color: 'neutral.600',
        bg: 'neutral.100'
      }
    },
    secondary: {
      bg: 'whiteAlpha.800',
      borderColor: 'primary.300',
      color: 'primary.700',
      borderWidth: '1px',
      borderStyle: 'solid',
      _hover: {
        bg: 'primary.50',
        _disabled: {
          bg: 'white'
        }
      },
      _active: {
        bg: 'primary.100'
      },
      _disabled: {
        opacity: '1',
        color: 'neutral.500',
        bg: 'white',
        borderColor: 'neutral.100'
      }
    },
    tertiary: {
      bg: 'whiteAlpha.800',
      color: 'primary.700',
      border: 'none',
      _hover: {
        bg: 'primary.50',
        _disabled: {
          bg: 'white'
        }
      },
      _active: {
        bg: 'primary.100'
      },
      _disabled: {
        opacity: '1',
        color: 'neutral.500',
        bg: 'white',
        borderColor: 'neutral.100'
      }
    }
  }
}
